export default {
  "member": "Membro del personale",
  "avatar": "Personale avatar",
  "viewAvatar": "Visualizza avatar per {name}",
  "search": "Ricerca personale per nome o e-mail",
  "allStatuses": "Tutti gli stati",
  "allRoles": "Tutti i ruoli",
  "name": "Nome",
  "role": "Ruolo",
  "status": "Stato",
  "certifications": "Certificazioni",
  "joined": "Abbonato",
  "joinedDate": "Adeguato {date}",
  "actions": "Azioni",
  "grid": "Vista Griglia",
  "list": "Visualizzazione elenco",
  "active": "Attivo",
  "inactive": "Inattivo",
  "call": "Membro del personale di chiamata",
  "message": "Membro del personale del messaggio",
  "noExtension": "Nessuna estensione assegnata",
  "noExtensionBody": "Questo membro del personale non ha un'estensione del telefono assegnata.",
  "callFailed": "Incapace di aprire il dialler",
  "conversationFailed": "Incapace di aprire la conversazione",
  "profileMissing": "Non abbiamo potuto determinare il tuo profilo personale per la messaggistica.",
  "selfMessage": "Non puoi mandare un messaggio da te",
  "selectOther": "Seleziona un altro membro del personale.",
  "retry": "Riprova.",
  "loadError": "Non è possibile caricare il personale. Si prega di riprovare.",
  "restricted": "Non hai accesso a questi registri del personale.",
  "empty": "Nessun personale trovato",
  "emptyHelp": "Prova a regolare i filtri o i termini di ricerca.",
  "loading": "Caricamento personale...",
  "oneResult": "{count} membro del personale",
  "manyResults": "{count} membri del personale",
  "clear": "Cancella filtri",
  "noCertifications": "Nessuna certificazione",
  "noReports": "Nessun rapporto diretto",
  "noManager": "Nessun responsabile di segnalazione assegnato",
  "noMatches": "Nessuna corrispondenza personale",
  "select": "Seleziona {name}",
  "certificationExpired": "{name} · Scadenza {date}"
}
